export default __webpack_public_path__ + "static/cover-3-8ccc2df4df514123cb3476ee948b042a.jpg";